import React from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faArrowRight, faCheck } from '@fortawesome/free-solid-svg-icons'

// Quem ainda nao usa o ERP conhece o Sobre Rodas pelo site do Workmotor.
const WORKMOTOR_URL = 'https://www.workmotor.com.br/'

const BENEFITS = [
  'Transparência que o cliente enxerga',
  'Histórico organizado sem trabalho manual extra',
  'Sua marca presente em cada atendimento',
]

export default function ProviderCTA({ onAccess }) {
  return (
    <section className='home-section home-provider' aria-labelledby='home-provider-title'>
      <div className='home-provider-text'>
        <span className='home-eyebrow home-eyebrow-light'>Para oficinas e autopeças</span>
        <h2 id='home-provider-title'>Cada atendimento bem registrado fortalece a confiança do cliente na sua oficina.</h2>
        <p>O Sobre Rodas recebe as informações dos atendimentos feitos no seu sistema. Seu cliente vê o cuidado que você entregou.</p>
        <ul className='home-provider-benefits'>
          {BENEFITS.map(benefit => (
            <li key={benefit}>
              <FontAwesomeIcon icon={faCheck} aria-hidden='true' />
              {benefit}
            </li>
          ))}
        </ul>
      </div>
      <div className='home-provider-actions'>
        <button type='button' className='home-btn home-btn-light' onClick={onAccess}>
          Acessar a área da oficina
          <FontAwesomeIcon icon={faArrowRight} aria-hidden='true' />
        </button>
        <a
          className='home-provider-link'
          href={WORKMOTOR_URL}
          target='_blank'
          rel='noopener noreferrer'
        >
          Quero o Sobre Rodas na minha oficina
          <FontAwesomeIcon icon={faArrowRight} aria-hidden='true' />
          <span className='home-visually-hidden'> (abre o site do Workmotor em nova aba)</span>
        </a>
      </div>
    </section>
  )
}
